import * as React from 'react';

const CancelCircleFilled24 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 11.527c0-6.075 4.924-11 11-11 6.074 0 11 4.925 11 11s-4.926 11-11 11c-6.076 0-11-4.925-11-11m8.707-3.234a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586z",
    clipRule: "evenodd"
  }
));
CancelCircleFilled24.Size = 24;
CancelCircleFilled24.Title = "CancelCircleFilled";

export { CancelCircleFilled24 as default };
